import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Login } from '../shared/interfaces/login.interface';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { NO_INTERCEPT } from '../shared/interceptors/auth-header.interceptor';

const URL = environment.host;
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private token: string = '';
  private http = inject(HttpClient);
  private baseUrl: string;
  private tokenUrl: string;
  BASE_URL='https://backoffice.aprendity.com';
  private access_token = new BehaviorSubject<string>('');
  private roles = new BehaviorSubject<string[]>([]);
  constructor() {
    this.baseUrl = 'https://backoffice.aprendity.com/user';
    this.tokenUrl = 'https://backoffice.aprendity.com/session/token';
  }

  getAuthorizationToken(name: string, pass: string): string {
    const user = name;
    const password = pass;
    const token = btoa(`${user}:${password}`);
    return token;
  }

  login(creds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }),
    };
    const url = `${URL}/user/login?_format=json`;
    return this.http.post<Login>(url, creds, httpOptions)
  }

  // Servicio para validar un correo electrónico
  validateEmail(email: string): Observable<any> {
    const URL = this.BASE_URL + '/api/validate-email';
    // const URL = `https://web-api.knowms.co/api/validate-email`;
    const params = new HttpParams().set('email', email);
    return this.http.get<any>(URL, { params })
  }

  setAccessToken(token: string) {
    this.access_token.next(token);
  }

  getAccessToken() {
    return this.access_token.asObservable(); // Devuelve un Observable para suscribirse
  }

  setRoles(roles: string[]) {
    this.roles.next(roles);
  }

  getRoles() {
    return this.roles.asObservable(); // Devuelve un Observable para suscribirse
  }

  getIdUser(bearer_token: string){
    const URL = `${this.BASE_URL}/api`;
    const headers = {
      Authorization: `Bearer ${bearer_token}`
    };
    return this.http.get(URL, { headers }).pipe(
      map((res: any) => res?.meta?.links?.me?.meta?.id ?? null)
    );
  }

  resetPassword(email: any): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'true',
        'Allow-Origin-With-Credentials': 'true',
      }),
      withCredentials: true,
    };
    const URL = this.baseUrl + '/lost-password?_format=json';
    return this.http.post(URL, email, httpOptions);
  }

  setPassword(payload: any): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'true',
        'Allow-Origin-With-Credentials': 'true',
      })
    };
    const URL = this.baseUrl + '/lost-password-reset?_format=json';
    return this.http.post(URL, payload, httpOptions);
  }

  // logout(){
  //   const jwtToken = this.getJwtToken();
  //   const csrfToken = this.getCsrfToken();
  //   const logoutToken = this.getLogoutToken();
  //   const headers = new HttpHeaders({ 'X-Csrf-Token': this.token });
  //   const requestOptions = { headers: headers}
  //   console.log(logoutToken)
  //   return this.http.post<any>(`${URL}/user/logout?_format=json&token=${logoutToken}`, {}, requestOptions);
  // }

  //LogoutWithCookie

  logout(){
    localStorage.removeItem('logout_token_edutegia');
    localStorage.removeItem('login_csrf_token_edutegia');
    localStorage.removeItem('current_user_edutegia');
    localStorage.removeItem('profile_current_user');
    localStorage.removeItem('authToken');
    localStorage.removeItem('userImg');
  }

  //Revisar
  logoutWithCookie(tokenLogout:any,globalTokenLoginLogout:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Csrf-Token': globalTokenLoginLogout || null,
      }),
      withCredentials: true,
    };
    const url = `${URL}/user/logout?_format=json&token=${tokenLogout}`;
    localStorage.clear();
    return this.http.post(url, {}, httpOptions);
  }

  getAuthToken(){
    return localStorage.getItem('authToken');
  }

  register(creds: any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': '*/*',
        'Content-Type': 'application/json'
      }),
    };
    const url = `${URL}/user/register?_format=json`;
    return this.http.post(url, creds, httpOptions);
  }

  loginStatus(): Observable<any>{
    const context = new HttpContext().set(NO_INTERCEPT, true);
    const url = `${URL}/user/login_status?_format=json`;
    return this.http.get(url, {
      responseType: 'text',
      context: context
    });
  }


  //New Services

  onLogin(name:string,pass:string,globalToken:string | any){
    console.log("name",name);
    // console.log("pass",pass);
    console.log("globalToken",globalToken);
    const body = {
      name,
      pass
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin':'http://localhost:4200/',
        'Access-Control-Allow-Credentials': 'true',
        'X-Csrf-Token': globalToken || null,
        'Allow-Origin-With-Credentials': 'true',
        // 'Access-Control-Allow-Headers':
        //   'Origin, X-Requested-With, Content-Type, Accept, X-XSRF-TOKEN, Cookie',
      }),
      withCredentials: true,
    };
    const url = this.BASE_URL+'/user/login?_format=json';
   return this.http.post(url, body, httpOptions);

  }


  onLogout(tokenLogout:any,globalTokenLoginLogout:any,){
    console.log("this.tokenLogout",tokenLogout);
    console.log("this.globalTokenLoginLogout",globalTokenLoginLogout);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Csrf-Token': globalTokenLoginLogout || null,
      }),
      withCredentials: true,
    };

    const url = `${this.BASE_URL}/user/logout?_format=json&token=${tokenLogout}`;

   return  this.http.post(url, {}, httpOptions);
  }



  onGetGlobalTokenLoginLogout(){
    const context = new HttpContext().set(NO_INTERCEPT, true);
    const url = URL+'/session/token';
    return this.http.get(url,{responseType:'text', context: context});
  }


}



